import styled from "styled-components";

export const FooterWrap = styled.div`
  .footer {
    background-color: #0f5a14;
    color: #ffffff;
    padding: 40px 20px;
    font-size: 20px;
  }

  .container {
    max-width: 1200px;
    margin: auto;
  }

  .footer-row {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }

  .col {
    flex: 1;
    min-width: 250px;
  }

  .footer-left h4,
  .footer-right h4 {
    margin-bottom: 10px;
    font-weight: 600;
  }
  .footer-left p:hover {
    color: #4caf50;
    /* transform: translateX(4px); */
  }

  .footer p,
  .footer .icon {
    cursor: pointer;
    transition:
      color 0.2s ease,
      transform 0.2s ease;
  }
  .footer-link:hover {
    color: #4caf50;
    font-weight: 600;
  }
  .social-icons .icon:hover {
    color: white;
    background-color: #4caf50;
    transform: scale(1.1);
  }
  .social-icons .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    margin-right: 8px;
    border-radius: 50%;
    border: 1px solid #4caf50;
  }

  .footer-left p,
  .footer-right p {
    margin: 4px 0;
    opacity: 0.9;
  }

  .footer-center {
    /* text-align: center; */
  }

  .footer-logo {
    width: 160px;
    margin-bottom: 10px;
  }

  .footer-link {
    cursor: pointer;
    margin: 4px 0;
    opacity: 0.9;
  }

  .footer-link:hover {
    text-decoration: underline;
  }

  .social-icons {
    display: flex;
    gap: 12px;
    margin: 10px 0;
  }

  .icon {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #ffffff;
    color: #0f5a14;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    cursor: pointer;
  }

  .footer-policy {
    margin-top: 12px;
    font-size: 12px;
    opacity: 0.85;
  }

  .copyright {
    margin-top: 10px;
    font-size: 12px;
    opacity: 0.8;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* background-color: #1f243b; */
    color: #e3e8fc;
  }

  .footer-text {
    display: flex;
    justify-content: space-between;
    color: #e3e8fc;
    font-size: 18px;
    font-weight: 400;
  }

  .break {
    color: white;
    margin-bottom: 20px;
  }

  .footer-link {
    font-size: 16px !important;
    font-weight: 400;
  }

  .footer-link :hover {
    color: #2d53da;
  }

  .link-style:hover {
    color: #2d53da;
  }

  @media screen and (max-width: 768px) {
    .footer-text {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      display: flex;
    }

    .footer-link {
      // font-size: 24px !important;
      font-weight: 400;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      row-gap: 25px;
    }

    .justify-content-center-mobile {
      justify-content: center !important;
      column-gap: 10px !important;
      font-size: 40px;
    }

    .socialmedia {
      margin-left: 0rem !important;
      margin-right: 0rem !important;
    }

    .footer-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
    }

    .text1 {
      font-size: 16px;
      font-weight: 400;
      padding-bottom: 2rem !important;
    }

    .text2 {
      font-size: 14px;
      font-weight: 400;
    }

    .img-footer {
      padding-bottom: 0rem !important;
    }
  }
`;
